import { BookingPeriodMonths, BookingPeriodStatus, BookingPeriodFilters } from "./Types";
import { FieldConfig } from "../../utils/GenericFilters";
import { FieldTypes } from "@vwpfs/mary-air-lib/components/air/07-organisms";

/**
 *
 */
export const BookingPeriodMonthsDisplay: Readonly<Record<BookingPeriodMonths, string>> = {
    [BookingPeriodMonths.JANUARY]: "January",
    [BookingPeriodMonths.FEBRUARY]: "February",
    [BookingPeriodMonths.MARCH]: "March",
    [BookingPeriodMonths.APRIL]: "April",
    [BookingPeriodMonths.MAY]: "May",
    [BookingPeriodMonths.JUNE]: "June",
    [BookingPeriodMonths.JULY]: "July",
    [BookingPeriodMonths.AUGUST]: "August",
    [BookingPeriodMonths.SEPTEMBER]: "September",
    [BookingPeriodMonths.OCTOBER]: "October",
    [BookingPeriodMonths.NOVEMBER]: "November",
    [BookingPeriodMonths.DECEMBER]: "December",
};

/**
 *
 */
export const BookingPeriodStatusDisplay: Readonly<Record<BookingPeriodStatus, string>> = {
    [BookingPeriodStatus.OPEN]: "Open",
    [BookingPeriodStatus.CLOSED]: "Closed",
};

/**
 * Options for BookingPeriod month filter - maps to numeric values 1-12
 */
export const BookingPeriodMonthOptions = Object.keys(BookingPeriodMonths).map((m, index) => ({
    label: BookingPeriodMonthsDisplay[m as BookingPeriodMonths],
    value: index + 1,
}));

/**
 * Options for BookingPeriod status filter
 */
export const BookingPeriodStatusOptions = Object.keys(BookingPeriodStatus).map(status => ({
    label: BookingPeriodStatusDisplay[status as BookingPeriodStatus],
    value: status,
}));

/**
 * Unified field configuration for BookingPeriod filters
 * Everything in one place - labels, types, and field-specific options!
 */
export const BookingPeriodFilterFieldsConfig: Record<keyof BookingPeriodFilters, FieldConfig> = {
    month: {
        label: "Month",
        type: FieldTypes.Select,
        options: BookingPeriodMonthOptions,
        placeholder: "Make a choice",
        unsorted: true, // Preserve chronological order (Jan-Dec)
    },
    year: {
        label: "Year",
        type: FieldTypes.Text, // Keep as text since it's a year input, not a numeric field
    },
};
